import { Flex } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const ShiftedFlex = styled(Flex)`
    transform: translateY(-25%);
    height: 28px;
`;
